<template>
  <div
    class="subnav-list"
    :class="{ 'subnav-list--expanded': expanded }"
  >
    <div
      v-if="title"
      class="subnav-list__heading"
    >
      {{ title }}
    </div>
    <div class="subnav-list__container">
      <NavigationItem
        v-for="navigationItem in items"
        :key="navigationItem.path"
        :navigation-item="navigationItem"
        class="subnav-list__item"
        :level="2"
        @subnav-open="$emit('subnav-open', $event)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ListItem } from '~/stores/navigation';
import NavigationItem from './navigation-item-lazy';

export type SubNavigationListProps = {
  expanded?: boolean;
  items: ListItem[];
  categoryPath?: string;
  title?: string;
};

const props = withDefaults(defineProps<SubNavigationListProps>(), {
  categoryPath: undefined,
  title: undefined,
});

defineEmits<{
  (e: 'subnav-open', src: number): void;
}>();
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.subnav-list {
  @include mq(false, $mq-lg - 1) {
    margin-bottom: $grid-base * 2;
  }

  &--expanded {
    @include mq(false, $mq-lg - 1) {
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
    }
  }

  &__container {
    @include mq($mq-lg) {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      align-content: flex-start;
      justify-content: flex-start;
      grid-gap: $grid-base * 0.5 $grid-base * 3;
      flex-wrap: wrap;
      max-height: 380px;
    }
  }

  &__heading,
  :deep(.main-navigation-item__link) {
    margin-bottom: 0;
    min-width: 100px;
  }

  &__heading {
    font-weight: 700;
    margin-bottom: $grid-base * 0.5;
    padding: $grid-base $grid-base * 2;
    color: var(--color-primary);

    @include mq(false, $mq-lg - 1) {
      border-bottom: 1px solid var(--color-stroke-subtle);
    }

    @include mq($mq-lg) {
      padding: 4px $grid-base * 1.5;
    }
  }
}
</style>
